
export const classes = (theme: any) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  businessCategoryList: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    margin: "0 auto",
    maxHeight: '20VH',
    color: theme.palette.primary.contrastText,
    // dont wrap on small screens
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
    },
  },
  businessCategoryButton: {
    margin: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderRadius: "30px",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "19px",
    color: theme.palette.primary.contrastText,
    textDecoration: "none",
    // backgroundColor: theme.palette.background.default,
    transition: "background-color 0.2s ease-in-out",
    // "&:hover": {
    //   backgroundColor: theme.palette.background.paper,
    // },
  },
  moreButton: {
    margin: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderRadius: "30px",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "19px",
    color: theme.palette.primary.contrastText,
    textDecoration: "none",
    // backgroundColor: theme.palette.background.default,
    transition: "background-color 0.2s ease-in-out",
    // "&:hover": {
    //   backgroundColor: theme.palette.background.paper,
    // },
  },
}
)
export default classes;
